import React from 'react';
import { BULK_PERFORMANCE_TYPES } from '../../../../constants/admin/settings';
import { CLEARING_OPTIONS } from '../../../../constants/settings';
import SelectField from '../../../forms/SelectField';
import DatepickerUnlimited from '../../../forms/DatepickerUnlimited';
import TextArea from '../../../forms/TextArea';
import { toSelectionFormat } from '../../../../lib/collection.utils';

const BulkPerformancesInput = ({ data, onInput, dependencies }) => (
    <div className="ckp-bulk-performances-form">
        <div className="ckp-admin-grid-column">
            <SelectField
                items={toSelectionFormat(dependencies.partners)}
                label="Select Partners to update"
                multiple
                onChange={onInput}
                name="partners"
                value={data.partners}
            />
        </div>
        <div className="ckp-admin-grid-column">
            {data.type === BULK_PERFORMANCE_TYPES.LIVE && (
                <SelectField
                    label="Select Live Status"
                    onChange={onInput}
                    name={'live'}
                    items={CLEARING_OPTIONS}
                    value={data.live}
                />
            )}
            {data.type === BULK_PERFORMANCE_TYPES.NON_LINEAR && (
                <SelectField
                    label="Select Non Linear Status"
                    onChange={onInput}
                    name={'nonLinear'}
                    items={CLEARING_OPTIONS}
                    value={data.nonLinear}
                />
            )}
            {data.type === BULK_PERFORMANCE_TYPES.USE_UNTIL && (
                <DatepickerUnlimited
                    onChange={onInput}
                    value={data.useUntil}
                    label="Non Linear Use Until"
                    name="useUntil"
                />
            )}
            {data.type === BULK_PERFORMANCE_TYPES.COMMENTS && (
                <TextArea label="Comments" name="comments" onChange={onInput} value={data.comments} />
            )}
        </div>
    </div>
);

export default BulkPerformancesInput;
